var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.135,
    height: 31.479,
    viewBox: "0 0 33.135 31.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#9f9f9f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.568,1.5C7.432,1.5,0,8.189,0,16.411a13.784,13.784,0,0,0,2.633,8.065c-.326,3.61-1.2,6.29-2.471,7.56a.552.552,0,0,0,.39.943.518.518,0,0,0,.077-.006,29.5,29.5,0,0,0,9.177-2.948,17.976,17.976,0,0,0,6.761,1.3c9.135,0,16.568-6.689,16.568-14.911S25.7,1.5,16.568,1.5ZM8.836,18.62a2.209,2.209,0,1,1,2.209-2.209A2.211,2.211,0,0,1,8.836,18.62Zm7.732,0a2.209,2.209,0,1,1,2.209-2.209A2.211,2.211,0,0,1,16.568,18.62Zm7.732,0a2.209,2.209,0,1,1,2.209-2.209A2.211,2.211,0,0,1,24.3,18.62Z",
    transform: "translate(0 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a5659b730479ba73c0e12eb88f20d189.svg";
export { ForwardRef as ReactComponent };